var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.86938,
    y: 0.354004,
    width: 17.9997,
    height: 21,
    rx: 1.49999,
    fill: "#2FB776"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86938 16.104H24.8691V19.854C24.8691 20.6824 24.1976 21.354 23.3691 21.354H8.36937C7.54095 21.354 6.86938 20.6824 6.86938 19.854V16.104Z",
    fill: "url(#paint0_linear_649_2858)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8689,
    y: 10.854,
    width: 8.99987,
    height: 5.25,
    fill: "#229C5B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8689,
    y: 5.604,
    width: 8.99987,
    height: 5.25,
    fill: "#27AE68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86938 1.85399C6.86938 1.02557 7.54095 0.354004 8.36937 0.354004H15.8693V5.604H6.86938V1.85399Z",
    fill: "#1D854F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.86938,
    y: 5.604,
    width: 8.99987,
    height: 5.25,
    fill: "#197B43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.86938,
    y: 10.854,
    width: 8.99987,
    height: 5.25,
    fill: "#1B5B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86938 7.85399C6.86938 6.61136 7.87674 5.604 9.11937 5.604H13.6193C14.8619 5.604 15.8693 6.61136 15.8693 7.85399V16.854C15.8693 18.0967 14.8619 19.104 13.6193 19.104H6.86938V7.85399Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.869141,
    y: 4.10352,
    width: 13.4998,
    height: 13.5,
    rx: 1.49999,
    fill: "url(#paint1_linear_649_2858)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6195 14.6045L8.50617 10.7795L10.5268 7.10449H8.8773L7.6299 9.45092L6.40311 7.10449H4.7021L6.733 10.7795L4.61963 14.6045H6.26909L7.59897 12.1188L8.91854 14.6045H10.6195Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_649_2858",
    x1: 6.86938,
    y1: 18.729,
    x2: 24.8691,
    y2: 18.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_649_2858",
    x1: 0.869141,
    y1: 10.8535,
    x2: 14.369,
    y2: 10.8535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176F3D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default __webpack_public_path__ + "static/media/IconExcel.038f9f55338b7b2e46273739d1e5f90d.svg";
export { ForwardRef as ReactComponent };